const actions = {
  SET_STATE: 'reports/SET_STATE',
  GET_REPORT_LIST: 'reports/GET_REPORT_LIST',
  GET_REPORT_BALANCE: 'reports/GET_REPORT_BALANCE',
  GET_REPORT_TRANSACTIONS: 'reports/GET_REPORT_TRANSACTIONS',
  GET_TRANSACTION_FEED: 'reports/GET_TRANSACTION_FEED',
}

export default actions
